import { useEffect } from 'react';

/**
 * Dismisses an open panel when the user presses outside it or presses Escape.
 * `mark` is the attribute selector that marks the panel *and* its triggers, so a
 * press on either of them keeps it open.
 */
export function useDismiss(active: boolean, mark: string, onDismiss: () => void): void {
  useEffect(() => {
    if (!active) return;
    const onDown = (event: PointerEvent): void => {
      const target = event.target;
      if (target instanceof Element && target.closest(mark)) return;
      onDismiss();
    };
    const onKey = (event: KeyboardEvent): void => {
      if (event.key === 'Escape') onDismiss();
    };
    window.addEventListener('pointerdown', onDown);
    window.addEventListener('keydown', onKey);
    return () => {
      window.removeEventListener('pointerdown', onDown);
      window.removeEventListener('keydown', onKey);
    };
  }, [active, mark, onDismiss]);
}
